import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SearchBarComponent } from '../searchbar/searchbar.component';
import { ModalOffcanvasService } from '../../../../services/modal-offcanvas.service';
import { RequestComponent } from '../../request/request.component';
import { ScreenSizeService } from '../../../../services/utils/screenSize.service';
import { SearchBarService } from '../../../../services/utils/searchBar.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  @Input() isShort: boolean = false;

  constructor(private modalOffcanvasService: ModalOffcanvasService, protected screenSize: ScreenSizeService, protected searchbarService: SearchBarService) { }

  openQuoteRequestModal() {
    const componentInputs = {
      scope: 'quote',
      isOffcanvas: this.screenSize.isMobile,
    };
    const options = {
      backdrop: 'static',
      centered: false,
      size: 'lg',
      scrollable: true,
      panelClass: 'app-offcanvas',
      position: 'bottom',
    };
    this.modalOffcanvasService.openComponent(RequestComponent, componentInputs, options);
  }

  get shortHeaderClass(): string {
    return this.isShort ? 'short-header' : '';
  }

  @Output() openModal = new EventEmitter<string>();
  @Output() toggleFiltering = new EventEmitter<boolean>();
  @ViewChild(SearchBarComponent) searchBarComp!: SearchBarComponent;

  triggerHandleSelect(item: any) {
    this.searchBarComp.handleSelect(item);
  }

}
